module.exports = __webpack_public_path__ + "static/media/reg-dep-kamion-branding.b092befa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/regionalna-deponija/reg-dep-kamion-branding.jpg
// module id = 441
// module chunks = 0